import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { featureToggleGuard } from 'ish-core/feature-toggle.module';

const routes: Routes = [
  {
    path: 'multiple-shipping-checkout',
    loadChildren: () =>
      import('./multiple-shipping-checkout/multiple-shipping-checkout-page.module').then(
        m => m.MultipleShippingCheckoutPageModule
      ),
    canActivate: [featureToggleGuard],
    data: {
      feature: 'multipleShippingCheckout',
      headerType: 'checkout',
      meta: {
        title: 'seo.title.checkout',
        robots: 'noindex, nofollow',
      },
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MultipleShippingCheckoutRoutingModule {}
